import type {ApplicationContext} from './api';
import {CustomerStripeTestInvoices} from './CustomerStripeTestInvoices';

export function stripeTestReturnKind(pathname:string):'return'|'cancel'|null {
  if(pathname==='/stripe-test-checkout/return')return 'return';
  if(pathname==='/stripe-test-checkout/cancel')return 'cancel';
  return null;
}

/** Arrival is navigation only. Query parameters are never read as payment or scope evidence. */
export function StripeTestCheckoutReturn({kind,context}:{kind:'return'|'cancel';context:ApplicationContext|null}) {
  const allowed=context?.workspace_kind==='customer' && context.capabilities.attorney_review===true
    && context.capabilities.stripe_test_checkout_http===true;
  return <section className="panel" aria-labelledby="stripe-test-return-title">
    <p className="eyebrow">PROFENZ, INC. · TEST CHECKOUT</p>
    <h2 id="stripe-test-return-title">{kind==='cancel'?'You left TEST checkout':'Back from TEST checkout'}</h2>
    <p>{kind==='cancel'
      ? 'Leaving checkout does not confirm that a session expired or a payment was canceled.'
      : 'Returning from checkout does not confirm that a payment succeeded.'} Check the local TEST records below before taking another action.</p>
    <p>No payment is approved, retried or canceled by this page.</p>
    {context===null?<p role="status">Sign in to the customer workspace used for checkout to view its available TEST records. <a className="button-link" href="/sign-in">Sign in</a></p>
      :allowed?<CustomerStripeTestInvoices key={`${context.organization.organization_id}:${context.identity.identity_id}`} enabled={true}
        scope={`${context.organization.organization_id}:${context.identity.identity_id}`}/>
      :<p role="status">TEST checkout records are not available in this workspace. Return to your workspace to check your account.</p>}
    <a className="button-link" href="/">Return to workspace</a>
  </section>;
}
